import React from "react";
import {
  Linking,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { Link } from "expo-router";
import { Image } from "expo-image";
import { MaterialCommunityIcons } from "@expo/vector-icons";

import { themes } from "@/Components/Styling/themeConfigs";
import { APP_STORE_LINK, PLAY_STORE_LINK } from "@/utils/links";

function MenuBar(): React.JSX.Element {
  const currentTheme = themes.morning;

  const styles = StyleSheet.create({
    container: {
      height: 70,
      flexDirection: "row",
      justifyContent: "space-between",
      borderBottomWidth: 1,
      borderBottomColor: currentTheme.borderColor,
      backgroundColor: currentTheme.backgroundColor,
    },
    section: {
      flexDirection: "row",
      alignItems: "center",
      gap: 12,
    },
    logo: {
      width: 40,
      height: 40,
    },
    brandName: {
      fontSize: currentTheme.typography.h1.size.web + 2,
      fontWeight: "600",
    },
    storeButton: {
      width: 155, // Set explicit width
      flexDirection: "row",
      alignItems: "center",
      padding: 12,
      borderRadius: 8,
      gap: 8,
    },
    title: {
      fontSize: currentTheme.typography.h2.size.web,
      color: "#FFFFFF", // White text for better contrast
    },
    appStoreButton: {
      fontSize: currentTheme.typography.h2.size.web, // Added font size
      fontWeight: "600", // Increased from 500
      backgroundColor: currentTheme.button.color.primary,
    },
    googlePlayButton: {
      backgroundColor: "#34A853", // Standard Google Play color
    },
  });

  const handleDownload = (storeLink: string): void => {
    Linking.openURL(storeLink);
  };

  return (
    <View style={styles.container}>
      <View style={styles.section}>
        <Image
          source={require("@/assets/images/icons/icon.png")}
          style={styles.logo}
        />
        <Link href="/" style={styles.brandName}>
          Kai Social
        </Link>
      </View>
      <View style={styles.section}>
        <TouchableOpacity
          style={[styles.storeButton, styles.appStoreButton]}
          onPress={() => handleDownload(APP_STORE_LINK)}
        >
          <MaterialCommunityIcons
            name="apple"
            size={currentTheme.icon.size.web.medium}
            color="#FFFFFF"
          />
          <Text style={styles.title}>App Store</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={[styles.storeButton, styles.googlePlayButton]}
          onPress={() => handleDownload(PLAY_STORE_LINK)}
        >
          <MaterialCommunityIcons
            name="google-play"
            size={currentTheme.icon.size.web.medium}
            color="#FFFFFF"
          />
          <Text style={styles.title}>Google Play</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

export default MenuBar;
